export class UserStorage {
  /**
   * Armazena as credenciais do usuário no localStorage.
   * @param usuario Nome do usuário
   * @param token Token de autenticação
   * @param id ID do usuário
   * @param img Imagem do usuário
   * @param empresa_id ID da empresa
   * @param controle_comandas Controle de comandas
   * @param impressora Configuração de impressora
   * @param contas_por_vendedor Contas vinculadas ao vendedor
   */
  setUser(
    usuario: string,
    token: string,
    id: string,
    img: string,
    empresa_id: string,
    controle_comandas: boolean,
    impressora: string,
    contas_por_vendedor: boolean
  ): void {
    const userData = {
      usuario,
      token,
      id,
      img,
      empresa_id,
      controle_comandas,
      impressora,
      contas_por_vendedor,
    };
    window.localStorage.setItem('credenciais', JSON.stringify(userData));
  }

  /**
   * Recupera as credenciais do usuário do localStorage.
   * @returns Dados do usuário ou null se não existir.
   */
  getUser(): Record<string, any> | null {
    const data = window.localStorage.getItem('credenciais');
    return data ? JSON.parse(data) : null;
  }


  /**
   * Armazena dados adicionais do usuário no localStorage.
   * @param img Imagem do usuário
   * @param nome Nome do usuário
   * @param tipo Tipo do usuário
   */
  setDados(img: string, nome: string, tipo: string): void {
    const additionalData = { img, nome, tipo };
    window.localStorage.setItem('dadosUsuario', JSON.stringify(additionalData));
  }

  /**
   * Recupera os dados adicionais do usuário do localStorage.
   * @returns Dados adicionais ou null se não existir.
   */
  getDados(): Record<string, any> | null {
    const data = window.localStorage.getItem('dadosUsuario');
    return data ? JSON.parse(data) : null;
  }

  clearUser() {
    localStorage.removeItem('credenciais'); // Remove as credenciais do usuário
    localStorage.removeItem('dadosUsuario'); // Remove dados adicionais do usuário
  }
}
